import { type ComponentProps } from 'react'
import { twMerge } from 'tailwind-merge'

interface SidepanelSectionLabelProps extends ComponentProps<'span'> {}

export function SidepanelSectionLabel({ className, children, ...props }: SidepanelSectionLabelProps) {
  return (
    <span className={twMerge('inline-flex items-center', className)} {...props}>
      {children}
    </span>
  )
}
